import Cookies from 'js-cookie'

export function determineAppropriateRootDomain(
  hostname?: string
): string | undefined {
  const currentHostname = hostname || window.location.hostname

  if (currentHostname === 'localhost' || currentHostname.startsWith('localhost:')) {
    return 'localhost'
  }

  const ipAddressRegex = /^(\d{1,3}\.){1,3}\d{1,3}(:\d+)?$/
  if (ipAddressRegex.test(currentHostname)) {
    return undefined
  }

  const parts = currentHostname.split('.')

  if (parts.length < 2) {
    return undefined
  }

  const multiPartTlds = [
    'co.uk',
    'org.uk',
    'gov.uk',
    'ac.uk',
    'com.au',
    'org.au',
    'gov.au',
    'co.jp',
    'ne.jp',
    'co'
  ]

  for (const multiTld of multiPartTlds) {
    if (currentHostname.endsWith(multiTld)) {
      const index = parts.length - multiTld.split('.').length - 1
      return parts.slice(index).join('.')
    }
  }

  return parts.slice(-2).join('.')
}

export function setSecureCookie(
  key: string,
  value: string,
  options: Cookies.CookieAttributes = {}
) {
  const rootDomain = determineAppropriateRootDomain()

  const cookieSettingStrategies = [
    () => {
      const secureOptions: Cookies.CookieAttributes = {
        path: '/',
        secure: true,
        sameSite: 'none',
        partitioned: true,
        ...options
      }

      try {
        Cookies.set(key, value, secureOptions)
        return true
      } catch (error) {
        console.warn('Failed to set cookie with root domain', error)
        return false
      }
    },
    () => {
      try {
        Cookies.set(key, value, {
          path: '/',
          secure: true,
          sameSite: 'none',
          partitioned: true,
          ...options
        })
        return true
      } catch (error) {
        console.error('Failed to set cookie with fallback strategy', error)
        return false
      }
    },
    () => {
      try {
        Cookies.set(key, value, { path: '/' })
        return true
      } catch (error) {
        console.error('Failed to set cookie with minimal settings', error)
        return false
      }
    }
  ]

  for (const strategy of cookieSettingStrategies) {
    if (strategy()) break
  }

  const storedValue = Cookies.get(key)
  if (!storedValue) {
    console.error('Cookie verification failed: Unable to retrieve set cookie')
  }
}

export function removeSecureCookie(key: string) {
  const rootDomain = determineAppropriateRootDomain()
  const currentHostname = window.location.hostname

  const removeOptions: Cookies.CookieAttributes[] = [
    {
      path: '/',
      domain: rootDomain,
      secure: true,
      sameSite: 'None', // Note the capital 'N'
      partitioned: true
    },
    {
      path: '/',
      domain: '.' + currentHostname,
      secure: true,
      sameSite: 'None', // Note the capital 'N'
      partitioned: true
    },
    {
      path: '/',
      secure: true,
      sameSite: 'None', // Note the capital 'N'
      partitioned: true
    },
    { path: '/' },
    {}
  ]

  removeOptions.forEach((options) => {
    try {
      Cookies.remove(key, options)
    } catch (error) {
      console.warn('Cookie removal attempt failed', error)
    }
  })

  // Remove from all storage mechanisms
  try {
    localStorage.removeItem(key)
    sessionStorage.removeItem(key)
  } catch (error) {
    console.warn('Storage removal error', error)
  }
}

export function getSecureCookie(key: string): string | undefined {
  const directCookie = Cookies.get(key)
  if (directCookie) return directCookie

  try {
    const rootDomain = determineAppropriateRootDomain()
    if (rootDomain) {
      const domainCookie = Cookies.get(key)
      if (domainCookie) return domainCookie
    }
  } catch (error) {
    console.warn('Error retrieving cookie with root domain', error)
  }

  try {
    const localStorageValue = localStorage.getItem(key)
    if (localStorageValue) return localStorageValue
  } catch (error) {
    console.warn('Error retrieving from localStorage', error)
  }

  try {
    const sessionStorageValue = sessionStorage.getItem(key)
    if (sessionStorageValue) return sessionStorageValue
  } catch (error) {
    console.warn('Error retrieving from sessionStorage', error)
  }

  console.warn(`No value found for cookie key: ${key}`)
  return undefined
}

export function hasCookie(key: string): boolean {
  return getSecureCookie(key) !== undefined
}

export function diagnoseIframeCookieIssues() {
  // const currentHostname = window.location.hostname;
  // const rootDomain = determineAppropriateRootDomain();
  // console.group('Cookie Storage Diagnostics');
  // console.log('Current Hostname:', currentHostname);
  // console.log('Determined Root Domain:', rootDomain);
  // console.log('Is Iframe:', window.self !== window.top);
  // console.log('Allow-Same-Origin Sandbox:',
  //   window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0
  // );
  // console.groupEnd();
}

export function debugCookies() {
  // console.group('Cookie Debugging');
  // try {
  //     const allCookies = Cookies.get();
  //     console.log('All Cookies:', allCookies);
  // } catch (error) {
  //     console.error('Error retrieving cookies', error);
  // }
  // console.log('Current Hostname:', window.location.hostname);
  // console.log('Root Domain:', determineAppropriateRootDomain());
  // console.log('Is Iframe:', window.self !== window.top);
  // console.groupEnd();
}
